import React, { Component } from 'react';

import './styles.scoped.scss';

class CashSummary extends Component {
  constructor() {
    super();
    this.state = {
      tab: 1,
    };
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table grid">
          <header />
          <main>
            <table className="dsr" data-name="Credit Sales">
              <thead>
                <tr data-header={true}>
                  <th className="alert-brand" colSpan="2">
                    Cash Summary
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> Opening cash balance </td>
                  <td>
                    {/* {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(summary.all_incomes || 0)} */}
                  </td>
                </tr>
                <tr>
                  <td>Closing cash balance </td>
                  <td>
                    {/* {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(summary.all_expenses || 0)} */}
                  </td>
                </tr>
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
export default CashSummary;
